import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import Tooltip from 'rc-tooltip'
import { head, get } from 'lodash'
import { StripeProvider, Elements } from 'react-stripe-elements'

import CustomerAreaTitle from '../Display/CustomerAreaTitle'
import CustomerAreaInfoLine from '../Display/CustomerAreaInfoLine'
import Button from 'Ui/Button'

import { formatPrice } from 'Helpers/format-helper'
import { STRIPE_PUBLIC_KEY } from 'Config/constants'
import { notify } from 'Actions/notifications'
import { openModal } from 'Actions/ui'
import { setCurrentUser } from 'Actions/user'
import { getUser } from '../../../api/user'
import { loadAddressSubscriptionProducts } from 'ActionCreators/ProductsActionCreators'

import '../Display/CustomerAreaDisplay.sass'
import 'rc-tooltip/assets/bootstrap.css'
import 'Ui/tooltip.sass'
import axiosClient from '../../../api/axios-client'
import SubscribeScanForm from '@components/SubscribeScanForm/SubscribeScanForm'
import ChangeIntervalForm from './ChangeIntervalForm'


const UNSUBSCRIBE_TYPEFORM_URL = 'https://form.typeform.com/to/PYzSiFl3'
const Loader = () => <img className="mb-6 ml-3" src="/assets/images/spinner.gif" alt="Veuillez patienter" />

export const offersAnnualDiscount = [
  {
    offerVersion: 'v2',
    discountRates: {
      1: 25,
      2: 35,
      3: 45,
    },
    discountTexts: {
      1: '25% de réduction',
      2: '35% de réduction',
      3: '45% de réduction',
    }
  },
]

const formatOptions = (selectedOption, offerVersion) => {
  if (offerVersion === 'v1') {
    switch (selectedOption) {
      case 'scan':
      default:
        return { expedition: '1 fois / mois', scan: 'Souscrit' }
      case 'exp4':
        return { expedition: '4 fois / mois', scan: 'Recevez votre courrier directement par email pour 10€ HT/mois sans engagement' }
      case 'exp1':
        return { expedition: '1 fois / mois', scan: 'Recevez votre courrier directement par email pour 10€ HT/mois sans engagement' }
      case 'scan_recyclage':
        return { expedition: 'Stockage 3 mois puis recyclage', scan: 'Souscrit' }
    }
  } else {
    switch (selectedOption) {
      case 'scan':
      default:
        return { expedition: 'Réexpédition 1 fois / mois', scan: 'Souscrit' }
      case 'scan_recyclage':
        return { expedition: 'Stockage 3 mois puis recyclage', scan: 'Souscrit' }
    }
  }
}

const formatDate = (date) => {
  return moment(date).format('DD/MM/YYYY')
}

class SubscriptionPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      subscription: null,
      nextInvoice: null,
      customer: null,
      prorationsLoading: false,
      changeOfferLoading: false,
    }
  }

  componentDidMount() {
    this.fetchCustomer()
    this.fetchSubscriptions()

    const { currentUser, dispatch } = this.props
    const address_id = head(currentUser.contracts)?.address_id
    if (address_id) loadAddressSubscriptionProducts(dispatch, address_id, { includeCreationOnboardingProduct: true, includeInactive: true })
  }

  // if currentUser wasn't loaded at componentDidMount, products could not be loaded so we need to load the products once user is loaded
  componentDidUpdate(prevProps) {
    const { currentUser, products, dispatch } = this.props

    if (!products.length && prevProps.currentUser?.id !== this.props.currentUser?.id) {
      const address_id = head(currentUser.contracts)?.address_id
      if (address_id) loadAddressSubscriptionProducts(dispatch, address_id, { includeCreationOnboardingProduct: true, includeInactive: true })
    }
  }

  async fetchCustomer() {
    try {
      const res = await axiosClient.get('/api/user/customer-details')

      this.setState({ customer: res.data })
    } catch (e) {
      this.props.dispatch(
        notify(
          'error',
          'Une erreur est survenue lors de la récupération des détails de votre abonnement.',
        ),
      )
    }
  }

  async fetchSubscriptions() {
    try {
      const res = await axiosClient.get('/api/user/subscription-details')

      this.setState({ subscription: res.data.subscription, nextInvoice: res.data.nextInvoice })
    } catch (e) {
      this.props.dispatch(
        notify(
          'error',
          'Une erreur est survenue lors de la récupération des détails de votre abonnement.',
        ),
      )
    }
  }

  getMonthlyEquivalentPriceAmout() {
    const { subscription } = this.state
    const { products } = this.props

    return subscription.items.data.reduce((acc, item) => {
      const product = products.find(p => p.id === item.price.product)
      const price = product.prices.find(p =>
        p.recurring?.interval === 'month'
        && p.recurring?.interval_count === 1
        && p.metadata.key === item.price.metadata.key
      )
      return acc + price.unit_amount
    }, 0)
  }

  getSubData() {
    const { subscription } = this.state
    const { products } = this.props

    if (!products.length) return null
    if (!subscription) return null

    const totalPrice = subscription.items.data.reduce((acc, item) => acc + item.plan.amount, 0)
    const { interval, interval_count } = subscription.items.data[0].plan

    const monthlyPrice = interval === 'month' ? totalPrice : this.getMonthlyEquivalentPriceAmout()

    return {
      interval,
      interval_count,
      totalPrice,
      monthlyPrice,
    }
  }

  refreshUser() {
    const { dispatch } = this.props

    getUser(res => {
      dispatch(setCurrentUser(res))
    })
  }

  async handleChangeOffer(stripe, { type, interval, interval_count }) {
    const { dispatch } = this.props
    this.setState({ changeOfferLoading: true })
    const url = type === 'interval'
      ? '/api/user/change-payment-interval'
      : '/api/user/subscribe-to-expedition-or-scan'

    const body = type === 'interval' ? { interval, interval_count } : {}

    try {
      const res = await axiosClient.post(url, body)

      console.log('res change offer ------------------------------------------>')
      console.log(res)
      const { validated, client_secret, subscription } = res.data
      this.setState({ subscription })

      if (!validated) {
        const res = await stripe.handleCardPayment(client_secret, {})
        console.log('res handleCardPayment ------------------------------------------>')
        console.log(res)

        this.setState({ changeOfferLoading: false })

        if (res.error) {
          dispatch(
            openModal('notification', {
              message: 'Changement d’offre validé, mais le paiement a été refusé, veuillez vérifier l’approvisionnement de votre carte et renseigner à nouveau un moyen de paiement dans l’onglet "Moyen de paiement".',
              buttonText: 'Ok',
            }),
          )

          return
        }
      }

      this.setState({ changeOfferLoading: false })
      dispatch(notify('success', 'Changement validé.'))
      this.fetchCustomer()
      this.fetchSubscriptions()
      this.refreshUser()
    } catch (e) {
      console.log('e ------------------------------------------>')
      console.log(e)
      this.setState({ changeOfferLoading: false })
      this.props.dispatch(
        notify('error', 'Une erreur est survenue lors de la modification de votre abonnement.'),
      )
    }
  }

  getOfferVersion() {
    const { currentUser } = this.props
    const contract = head(currentUser.contracts)

    return get(contract, 'offer_version', 'v1')
  }

  async getIntervalProrationsAndOpenModal(stripe, newInterval, newIntervalCount) {
    const { monthlyPrice } = this.getSubData()
    this.setState({ prorationsLoading: true })
    let newPrice = monthlyPrice

    if (newInterval === 'year') {
      const discountPercent = get(offersAnnualDiscount.find(offer => offer.offerVersion === 'v2'), `discountRates.${newIntervalCount}`, 0)
      newPrice = monthlyPrice * (1 - discountPercent / 100) * 12 * newIntervalCount
    }

    try {
      const res = await axiosClient.get(`/api/user/change-payment-prorate?interval=${newInterval}&interval_count=${newIntervalCount}`)
      this.setState({ prorationsLoading: false })
      const proration = res.data.reduce((acc, item) => acc + item.amount, 0) / 100 * -1

      this.props.dispatch(
        openModal('confirmPaymentInterval', {
          onValidate: () => this.handleChangeOffer(stripe, { type: 'interval', interval: newInterval, interval_count: newIntervalCount }),
          newPrice,
          proration,
          balance: this.getTTCCustomerBalance() / -100,
        }),
      )
    } catch (e) {
      this.setState({ prorationsLoading: false })
      console.log('e ------------------------------------------>')
      console.log(e)
      this.props.dispatch(
        notify(
          'error',
          'Une erreur est survenue lors de la récupération des détails de votre abonnement.',
        ),
      )
    }
  }

  handleRecyclageSubmit() {
    const { dispatch } = this.props

    fetch(`/api/user/${this.props.currentUser.id}/submit-recyclage`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })
      .then(res => {
        if (res.status !== 200) throw new Error(res.error)

        return res
      })
      .then(res => res.json())
      .then(res => {
        dispatch(setCurrentUser(res))
        dispatch(notify('success', 'Vous avez bien souscrit à l’option recyclage.'))
      })
      .catch(() => dispatch(notify('error', 'Une erreur est survenue.')))
  }

  async handleUnsubscribeCaarl() {
    const { dispatch } = this.props
    try {
      const res = await axiosClient.post('/api/caarl/unsubscribe')

      dispatch(setCurrentUser(res.data.user))
      dispatch(notify('success', 'Vous avez bien été désabonné de l’assistance juridique CAARL.'))

    } catch (e) {
      console.log('e ------------------------------------------>')
      console.log(e)
      dispatch(notify('error', 'Une erreur est survenue lors de l’annulation de votre abonnement. Merci de contacter notre service client.'))
    }
  }

  getTTCCustomerBalance() {
    const { customer } = this.state
    if (!customer) return 0
    const { balance } = customer

    return Math.round(balance * 0.833333 * 100) / 100 // we receive it in TTC
  }

  renderSubscriptionInfo(contract) {
    const { subscription, prorationsLoading, changeOfferLoading, nextInvoice } = this.state
    const subData = this.getSubData()
    if (!subData) return <Loader />

    let nextPayment = ''
    if (subscription && nextInvoice) {
      const priceTotal = nextInvoice.total_excluding_tax
      nextPayment = `${formatPrice(priceTotal / 100)} HT le ${moment
        .unix(subscription.current_period_end)
        .format('DD/MM/YYYY')}`
    }

    return (
      <div className="customer-area-info-block">
        <CustomerAreaInfoLine
          label="Date d’inscription"
          value={formatDate(get(contract, 'created_at'))}
        />
        <CustomerAreaInfoLine label="Prochain paiement" value={nextPayment} />
        <CustomerAreaInfoLine
          label="Fréquence de facturation"
          value={
            <ChangeIntervalForm
              onClickChangeInterval={this.getIntervalProrationsAndOpenModal.bind(this)}
              subData={subData}
              subscription={this.state.subscription}
              prorationsLoading={prorationsLoading}
              changeOfferLoading={changeOfferLoading}
            />
          }
        />
      </div>
    )
  }

  renderTooltip() {
    const tooltipText = (
      <div className="Tooltip">
        Vos courriers sont stockés 3 mois à partir de la date de numérisation, puis sont détruits et
        recyclés au lieu de vous être réexpédiés. En cas de courrier important, vous avez 3 mois
        pour nous demander la réexpédition à votre domicile.
      </div>
    )

    return (
      <Tooltip placement="top" trigger={['click']} overlay={tooltipText}>
        <div className="Tooltip-trigger">?</div>
      </Tooltip>
    )
  }

  renderExpeditionOptions(contract) {
    const { prorationsLoading, changeOfferLoading, subscription } = this.state
    const { expedition_frequency, offer_version } = contract
    const options = formatOptions(expedition_frequency, offer_version)
    const subData = this.getSubData()
    if (!subData) return <Loader />
    const { interval } = subData

    let subscribeToPaidExpeditionButton = null
    let subscribeToScanButton = null
    let recyclageLine = null

    // for old offers with free expedition and non-free scan
    if (offer_version === 'v1' && ['exp1', 'exp4'].includes(expedition_frequency)) {
      subscribeToScanButton = (
        <div className='mt-4'>
          {!!subscription && (
            <SubscribeScanForm
              isLoading={prorationsLoading || changeOfferLoading}
              interval={interval}
              offerVersion={offer_version}
              setIsLoading={(value) => this.setState({ prorationsLoading: value })}
              handleChangeOffer={this.handleChangeOffer.bind(this)}
            />
          )}
        </div>
      )
    }

    if (offer_version === 'v1' && expedition_frequency === 'scan') {
      recyclageLine = (
        <CustomerAreaInfoLine
          label={
            <>
              <div className="label-with-tooltip">Option recyclage (gratuite)</div>
              {this.renderTooltip()}
            </>
          }
          value={
            <Button
              label="Souscrire"
              onClick={this.handleRecyclageSubmit.bind(this)}
              secondaryClass="primary small-height"
            />
          }
          secondaryClass="primary"
        />
      )
    }

    if (offer_version !== 'v1' && expedition_frequency === 'scan_recyclage') {
      subscribeToPaidExpeditionButton = (
        <div className='mt-4'>
          <div>Réexpédition mensuelle (10€ HT/mois sans engagement) :</div>
          <SubscribeScanForm
            isLoading={prorationsLoading || changeOfferLoading}
            interval={interval}
            offerVersion={offer_version}
            setIsLoading={(value) => this.setState({ prorationsLoading: value })}
            handleChangeOffer={this.handleChangeOffer.bind(this)}
          />
        </div>
      )
    }

    return (
      <div className="customer-area-info-block">
        <CustomerAreaInfoLine label="Réexpédition courrier" value={
          <>
            {get(options, 'expedition')} :<br/>Souscrit
            {subscribeToPaidExpeditionButton}
          </>
        }/>
        <CustomerAreaInfoLine label="Scan numérique quotidien" value={
          <>
            {get(options, 'scan')}
            {subscribeToScanButton}
          </>
        }/>
        {recyclageLine}
      </div>
    )
  }

  renderUnsubscribe() {
    return (
      <div className="customer-area-unsubscribe">
        <div className="customer-area-subtext">
          • Le désabonnement est réalisé sous 24h, sans préavis. Merci de faire votre demande quand
          vous êtes certain de ne plus vouloir recevoir aucun courrier à notre adresse.
          <br />
          <br />• Après désabonnement, vous n'aurez plus accès à votre espace client, et donc à vos
          factures. Merci de les télécharger avant de faire votre demande.
        </div>
        <Button
          label="Formulaire de désabonnement"
          onClick={() => window.open(UNSUBSCRIBE_TYPEFORM_URL, '_blank')}
          secondaryClass="primary small-height"
        />
      </div>
    )
  }

  renderUnsubscribeCaarl() {
    return (
      <div className="customer-area-unsubscribe">
        <div className="customer-area-subtext">
          Votre abonnement à l'assistance juridique avec Caarl est actuellement actif.<br/>
          Si vous souhaitez mettre fin à cet abonnement, cliquez sur le bouton ci-dessous. L'abonnement prendra fin immédiatement et vous n'aurez plus accès au service.
        </div>
        <Button
          label="Se désabonner de l’assistance juridique"
          onClick={() => this.handleUnsubscribeCaarl()}
          secondaryClass="primary small-height"
        />
      </div>
    )
  }

  render() {
    const { currentUser } = this.props
    if (!currentUser.company) return null
    const stripeAccount = get(this.props, 'currentUser.company.idStripeAccount') || undefined

    const contract = head(currentUser.contracts)

    return (
      <StripeProvider apiKey={STRIPE_PUBLIC_KEY} stripeAccount={stripeAccount}>
        <Elements locale="fr">
          <>
            <CustomerAreaTitle label="Mon abonnement" icon="ic-mon-abonnement" mobilePadding />
            {this.renderSubscriptionInfo(contract)}
            <CustomerAreaTitle label="Mes options" mobilePadding />
            {this.renderExpeditionOptions(contract)}
            <CustomerAreaTitle label="Désabonnement" mobilePadding />
            {this.renderUnsubscribe()}
            {currentUser.caarl_subscription && (
              <>
                <div className="mt-16" />
                <CustomerAreaTitle label="Assistance juridique" mobilePadding />
                {this.renderUnsubscribeCaarl()}
              </>
            )}
          </>
        </Elements>
      </StripeProvider>
    )
  }
}

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
  products: state.products.subscriptionProducts.products,
})

export default connect(MapStateToProps)(SubscriptionPage)
